interface ApiErrorResponse {
  response?: {
    data?: {
      detail?: unknown;
    };
  };
}

export const getApiErrorDetail = (response: unknown): string | undefined => {
  const err = response as ApiErrorResponse;
  const detail = err?.response?.data?.detail;
  return typeof detail === 'string' && detail.trim() ? detail : undefined;
};
